import React from "react";
import ReactDOM from "react-dom";
import components from "./components";

const mount = () => {
  Array.from(document.querySelectorAll("[data-component]")).forEach(
    (element) => {
      const name = element.dataset.component;
      const Component = components[name];

      if (!Component) return;

      const initialProps = JSON.parse(element.dataset.props || "{}");

      ReactDOM.render(
        <React.StrictMode>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Component {...initialProps} />
        </React.StrictMode>,
        element,
      );
    },
  );
};

document.addEventListener("DOMContentLoaded", () => {
  // Mount the React components when DOMContent loaded.
  mount();
  // ACF not defined
  if (acf) {
    // Mount the React components when an ACF block has generated its preview.
    acf.addAction("render_block_preview", mount);
    // Mount the React components when an ACF block preview is remounted.
    acf.addAction("remount", mount);
  }
});
